<template>
    <div class="search-content-dropdown" v-on-clickaway="clearSearchResults" >
        <input   v-model="searchTerm" type="text" v-bind:placeholder="placeholder" class="search-input" v-on:keyup="getArticlesDataTimeout(searchTerm)" v-on:focus="getArticlesData(searchTerm)"/>
        <div class="loading-overlay"></div>
        <div class="dropdown-select-box"  v-bind:class="{ 'is-active': showFoundArticles}">
             <div class="select-option select-option--noResults">
                <div class="select-option--text">
                    <div class="magenta" v-html="noResults"></div>
                </div>              
            </div>
            <div class="select-option" v-for="(article) in matchingArticles" v-bind:key="article.id">
                <div class="select-option--text">
                    <p class="magenta"><a v-bind:href="article.url" target="_blank">{{article.title}}</a></p>
                    <p v-html="article.dateString"></p>
                </div>
                <div class="select-option--action">
                    <template v-if="!articleExistsInAddedArticles(article.id)">
                        <button v-on:click="addArticle(article)">+</button>
                    </template>
                    <template v-else>
                        Added&nbsp;<img src="/assets/images/ckp/tick.svg" style="width:16px" />
                    </template>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import axios from 'axios';

export default {
        name: "ArticleSearch",
        
        data() {
            return {
                dataUrl: "/Assets/data/",
                localUiTestingUrl: "https://neu-ckp-uat-sc-xp-single.azurewebsites.net",
                searchTerm: "",
                matchingArticles: {
                    data: []
                },
                showFoundArticles: false,
                timerHandle: null,
                noResults: "No Results..."
            }
        },

        mixins: [ clickaway ],
        
        props: {
            addedArticles: Object,
            topics: Array,
            sectors: Array,
            jurisdictions: Array,
            categories: Array,
            toDate: String,
            fromDate: String,
            placeholder: String
        },

        methods: {
            
            getArticlesDataTimeout(searchTerm) {

                var self = this;
                clearTimeout(this.timerHandle);

                this.timerHandle = setTimeout(function() {
                    self.getArticlesData(searchTerm);
                }, 500);
            },

            getArticlesData(searchTerm){
                
                // Dont do anything if no input data submitted
                if (
                    !this.searchTerm.length &&
                    !this.topics.length &&
                    !this.sectors.length &&
                    !this.jurisdictions.length &&
                    !this.categories.length &&
                    !this.toDate.length &&
                    !this.fromDate.length
                ) {
                    return;
                }
                
                var self = this;
                var $ = window.$;
                // let dataUrl =  this.dataUrl + 'article-search.json';
                let articlesID = [];
                this.addedArticles.articles.forEach( function(art){
                    articlesID.push(art["id"]);
                });
                let data = {
                    search: searchTerm,
                    take: 20,
                    addedArticleIds: articlesID,
                    topics: this.topics,
                    sectors: this.sectors,
                    jurisdictions: this.jurisdictions,
                    categories: this.categories,
                    toDate: this.toDate,
                    fromDate: this.fromDate
                };

                let dataUrl = "/webapi/ckp/contentsharing/articleautocompletesearch";

                if (document.location.host.includes("localhost")) {
                    dataUrl = this.localUiTestingUrl + dataUrl;
                }

                const options = {
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    data: JSON.stringify(data),
                    url: dataUrl
                }

                $('.loading-overlay').addClass('is-active');
                axios(options)
                .then(response => {
                    $('.select-option--noResults').hide();
                    // console.log('response', response.data);
                    if (response.data.success) {
                        self.matchingArticles = response.data.results;
                    }
                    if (response.data.results && !response.data.results.length) {
                        $('.select-option--noResults').show();
                        self.matchingArticles = [];
                        self.noResults = response.data.noResult;
                    }
                }).catch(function (error) {
                    console.log('loading articles error', error);
                }).then(() => {
                    $('.loading-overlay').removeClass('is-active');
                });

                this.showFoundArticles = true;
            },
            
            articleExistsInAddedArticles(id) {
                let articleExists = false;
                this.addedArticles.articles.forEach(function (art){
                    
                    if(art['id'] == id){
                        articleExists = true;
                    }
                })
                return articleExists;                
            },
            
            addArticle(article) {  
                if(!this.articleExistsInAddedArticles(article['id'])){
                    this.addedArticles.articles.push(article);
                }
            },

            clearSearchResults() {
                var $ = window.$;
                var self = this;
                $('.dropdown-select-box').animate({ scrollTop: 0 }, 1);
                setTimeout(function () {
                    self.showFoundArticles = false;
                    self.searchTerm = "";
                }, 50);           
            }
        },
    };
</script>